<template>
  <div class="content">
    <controlbar :dispItems="posts" @input-event="setPost" @list-reload="reload">
    </controlbar>
    <div class="center">
      <table class="content_title" rules="rows">
        <tr class="items_table">
          <th class="table_checkbox">
            <input
              type="checkbox"
              class="checkbox"
              :checked="checked"
              @click="allCheckedAction"
            />
          </th>
          <td class="belongList_table_contents">
            <label class="post_id_label">
              {{ postIdLabel }}
            </label>
          </td>
          <td class="belongList_table_contents">
            <label class="post_code_label">
              {{ postCodeLabel }}
            </label>
          </td>
          <td class="belongList_table_contents">
            <label class="post_name_label">
              {{ postNameLabel }}
            </label>
          </td>
          <td class="belongList_table_contents">
            <label class="post_parent_label">
              {{ postParentLabel }}
            </label>
          </td>
        </tr>
      </table>

      <div class="table_scroll" :style="{height: tableHeight}">
        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="dispBelong in posts"
            :key="dispBelong.postID"
          >
            <th class="table_checkbox">
              <input
                type="checkbox"
                class="checkbox"
                v-model="dispBelong.checked"
                @click="checkedAction(dispBelong)"
              />
            </th>
            <td class="belongList_table_contents" @click="setActive(dispBelong)">
              <label class="post_id">
                {{ dispBelong.postId }}
              </label>
            </td>
            <td class="belongList_table_contents" @click="setActive(dispBelong)">
              <label class="post_code">
                {{ dispBelong.postCode }}
              </label>
            </td>
            <td class="belongList_table_contents" @click="setActive(dispBelong)">
              <label class="post_name">
                {{ dispBelong.postName }}
              </label>
            </td>
            <td class="belongList_table_contents" @click="setActive(dispBelong)">
              <label class="post_name">
                {{ dispBelong.parentPostName }}
              </label>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="bottom">
      <pagination
        v-model="page"
        :records="total"
        :per-page="pageSize"
        :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
        @paginate="setPost(page - 1)"
      >
      </pagination>
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <falseModalWindow :question="falseWord" @close="close"> </falseModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controlbar from './controlbar.vue'
import Pagination from 'vue-pagination-2'
import falseModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      postIdLabel: '所属ID',
      postCodeLabel: '所属コード',
      postNameLabel: '所属名',
      postParentLabel: '親所属',
      showFalseModal: false,
      windowHeight: '',
      falseWord: '',
      checked: false,
      inputValue: '',
      showloadingModal: false,
      pageSize: 20,
      page: 1,
      prevTotal: 0,
      prevPageNo: 0,
      prevSearchWord: ''
    }
  },
  computed: {
    posts() {
      return this.$store.state.belongs.posts
    },
    total() {
      if ((this.page - 1) * this.pageSize <= this.$store.state.belongs.total) {
        return this.$store.state.belongs.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (this.page - 1) * this.pageSize >= this.$store.state.belongs.total
    },
    lastPage() {
      const last = Math.ceil(this.$store.state.belongs.total / this.pageSize)
      return last === 0 ? 1 : last
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    tableHeight() {
      const otherHeight = 138
      return this.windowHeight - otherHeight + 'px'
    }
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.$store.dispatch('belongs/clearSelectedPostList')
    this.$store.state.prevPageNo = 0
    this.$store.state.prevSearchWord = ''
    this.setPost(0)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    controlbar,
    Pagination,
    falseModalWindow,
    loadingModalWindow
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    allCheckedAction(e) {
      // リストのチェックボックスを全てチェックする。
      this.checked = !this.checked
      for (let i = 0; i < this.posts.length; i++) {
        this.posts[i].checked = this.checked
      }
      this.$store.dispatch('belongs/updateSelectedPostList', this.posts)
    },
    checkedAction(post) {
      post.checked = !post.checked
      this.$store.dispatch('belongs/updateSelectedPostList', [post])
    },
    close(e) {
      this.showFalseModal = false
    },
    async reload() {
      this.$store.dispatch('belongs/clearSelectedPostList')
      await this.setPost(
        this.$store.state.prevPageNo,
        this.$store.state.prevSearchWord
      )
    },
    async setPost(pageNo, searchWord = null) {
      this.showloadingModal = true
      let focus = document.activeElement
      focus.blur()
      try {
        searchWord =
          searchWord === null ? this.$store.state.prevSearchWord : searchWord
        await this.$store.dispatch('belongs/setPosts', {
          pageNo: pageNo,
          searchWord: searchWord
        })
        if (pageNo > 0) {
          if (this.isOverPage) {
            this.page = this.lastPage
          } else {
            this.page = pageNo + 1
          }
        }else{
          this.page = 1
        }
        this.$store.state.prevPageNo = pageNo
        this.$store.state.prevSearchWord = searchWord
        this.checked = false
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_200001
        let eventType = 3
        let reason = 'MSGCRC0035 '
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0035.name +
            this.errorMsg.MSGCRC0035.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    },
    async setActive(payload) {
      this.showloadingModal = true
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      try {
        await this.$store.dispatch('belongs/setDetailPost', payload)
        if (location.pathname !== '/belongs/detail') {
          this.$router.push('../belongs/detail')
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_200002
        let eventType = 3
        let reason = 'MSGCRC0036 '
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0036.name +
            this.errorMsg.MSGCRC0036.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/belongs/belongsList.vue